import { PaymentType } from "../../types/types";
import { MarketplaceCardResponseDto, OpportunityCardResponseDto } from "../../types/types";
import { getPaymentType } from "./dealFormValueUtils";
import { normalizePaymentTiming } from "./dealNormalizers";
import { SavedComponentPayment } from "../../pages/deals/createDeal/dealFormTypes";

// Payment rows read from a saved deal (snake_case rows can come from older data).
type PaymentDateItem = {
  paymentTiming?: string;
  payment_timing?: string;
  dueOn?: string;
  paidOn?: string;
  paid_on?: string;
};

// Some cards carry componentPayments directly instead of only inside formData.
type EditedCard = MarketplaceCardResponseDto & {
  componentPayments?: PaymentDateItem[];
  opportunityCardResponse?: OpportunityCardResponseDto & {
    componentPayments?: PaymentDateItem[];
  };
};

function getSavedPaymentDates(
  savedComponentPayments: SavedComponentPayment[] | undefined,
  editedCard: MarketplaceCardResponseDto | null,
): { pre: string; post: string } {
  const card = editedCard as EditedCard | null;
  const src: PaymentDateItem[] = savedComponentPayments?.length
    ? savedComponentPayments
    : (card?.opportunityCardResponse?.componentPayments ??
      card?.componentPayments ??
      editedCard?.opportunityCardResponse?.formData?.componentPayments ??
      []);

  if (!Array.isArray(src) || src.length === 0) return { pre: "", post: "" };

  const isSplit = getPaymentType(editedCard?.opportunityCardResponse?.formData) === PaymentType.SPLIT;

  let pre = "";
  let post = "";

  for (const ep of src) {
    const timing = normalizePaymentTiming(
      ep.paymentTiming || ep.payment_timing || "",
    );
    const dateVal = ep.dueOn ?? ep.paidOn ?? ep.paid_on ?? "";
    if (!dateVal) continue;
    if (timing === "PRE_MATCH" && !pre) pre = dateVal;
    if (timing === "POST_MATCH" && !post && isSplit) post = dateVal;
  }

  return { pre, post };
}

export { getSavedPaymentDates };
